import Login from './admin/login';
import CF7 from './admin/cf7';
import AcfSvgField from './admin/acf-svg-field';
import UsersList from  './admin/usersList';

jQuery(function () {
	Login.init();
	CF7.init();
	AcfSvgField.init();
	UsersList.init();
});
